// extracted by mini-css-extract-plugin
export var gif = "_ka-0";